import React, { useState } from "react";
import { staffAPI } from "../services/api";
import "./StaffCheckIn.css";

const StaffCheckIn = ({ bookingId, appointmentDate, refreshBookings }) => {
  const [isCheckingIn, setIsCheckingIn] = useState(false);
  const now = new Date();
  const appt = new Date(appointmentDate);
  // Allowed check-in time: 15 minutes before the appointment starts.
  const allowedCheckInTime = new Date(appt.getTime() - 15 * 60000);

  // Do not render the check-in button if it's too early.
  if (now < allowedCheckInTime) {
    return null;
  }

  const handleStaffCheckIn = async () => {
    setIsCheckingIn(true);
    try {
      await staffAPI.checkInBooking(bookingId);
      if (refreshBookings) refreshBookings();
    } catch (error) {
      console.error(
        "Error during staff check-in:",
        error.response ? error.response.data : error
      );
      alert(error.response?.data?.message || "Error during staff check-in.");
    } finally {
      setIsCheckingIn(false);
    }
  };

  return (
    <button
      className="action-btn action-btn-check-in"
      onClick={handleStaffCheckIn}
      disabled={isCheckingIn}
    >
      {isCheckingIn ? "Checking In..." : "Check In"}
    </button>
  );
};

export default StaffCheckIn;
